<template>
  <div>
    <div class="main-content card p-3">
      <!-- Cabeçalho -->
      <div
        class="d-flex justify-content-between align-items-center mb-3 flex-wrap"
      >
        <div>
          <h4 class="mb-0">
            <i class="fas fa-heartbeat text-danger mr-2"></i>Painel
            Administrativo do Sistema
          </h4>
          <small class="text-muted" v-if="dados.gerado_em">
            Atualizado em {{ dados.gerado_em }}
          </small>
        </div>
        <div class="d-flex align-items-center flex-wrap">
          <div class="btn-group btn-group-sm mr-3" role="group">
            <button
              v-for="p in periodos"
              :key="p.valor"
              class="btn"
              :class="
                periodo === p.valor ? 'btn-primary' : 'btn-outline-primary'
              "
              @click="setPeriodo(p.valor)"
            >
              {{ p.label }}
            </button>
          </div>
          <div class="custom-control custom-switch mr-3">
            <input
              type="checkbox"
              class="custom-control-input"
              id="autoRefresh"
              v-model="autoRefresh"
            />
            <label class="custom-control-label" for="autoRefresh">
              Auto-atualizar (15s)
            </label>
          </div>
          <button
            class="btn btn-primary btn-sm"
            @click="carregar()"
            :disabled="carregando"
          >
            <i
              class="fas"
              :class="carregando ? 'fa-spinner fa-spin' : 'fa-sync-alt'"
            ></i>
            Atualizar
          </button>
        </div>
      </div>

      <!-- Banner de status geral (para o suporte ler de relance) -->
      <div class="status-banner mb-3" :class="'sb-' + statusGeral.nivel">
        <i class="fas fa-2x mr-3" :class="iconeStatus(statusGeral.nivel)"></i>
        <div>
          <div class="sb-titulo">{{ statusGeral.titulo }}</div>
          <div class="sb-detalhe">{{ statusGeral.detalhe }}</div>
        </div>
      </div>

      <!-- Infra: Banco / Redis / WebSocket -->
      <div class="row">
        <div
          class="col-md-4 mb-3"
          v-for="(item, nome) in dados.infra"
          :key="nome"
        >
          <div
            class="card h-100 border-left-status"
            :class="item.ok ? 'st-ok' : 'st-down'"
          >
            <div class="card-body py-3">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <div
                    class="text-muted text-uppercase"
                    style="font-size: 11px; letter-spacing: 0.5px"
                  >
                    {{ rotuloInfra(nome) }}
                  </div>
                  <div class="font-weight-bold" style="font-size: 18px">
                    <span :class="item.ok ? 'text-success' : 'text-danger'">
                      <i
                        class="fas mr-1"
                        :class="item.ok ? 'fa-check-circle' : 'fa-times-circle'"
                      ></i>
                      {{ item.ok ? "Online" : "Indisponível" }}
                    </span>
                  </div>
                  <small
                    class="text-muted d-block"
                    v-if="item.ok && item.ms !== undefined"
                  >
                    Respondeu em {{ item.ms }} ms
                  </small>
                  <small
                    class="text-danger d-block"
                    v-else-if="!item.ok"
                    :title="item.erro"
                  >
                    Sem resposta — acionar a equipe técnica
                  </small>
                  <small
                    class="text-muted d-block mt-1"
                    style="font-size: 11px"
                  >
                    {{ descricaoInfra(nome) }}
                  </small>
                </div>
                <i
                  class="fas fa-2x"
                  :class="[
                    iconeInfra(nome),
                    item.ok ? 'text-success' : 'text-danger',
                  ]"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Filas -->
      <div class="row">
        <div class="col-md-12 mb-3">
          <div class="card">
            <div
              class="card-header py-2 d-flex justify-content-between align-items-center"
            >
              <b
                ><i class="fas fa-layer-group mr-2 text-primary"></i>Filas
                (jobs)</b
              >
              <span>
                <span class="badge badge-secondary mr-1"
                  >{{ dados.filas.pendentes }} pendentes</span
                >
                <span
                  class="badge"
                  :class="
                    dados.filas.falhados > 0 ? 'badge-danger' : 'badge-success'
                  "
                >
                  {{ dados.filas.falhados }} falhados
                </span>
              </span>
            </div>
            <div class="card-body py-3">
              <div class="filas-grid">
                <div
                  class="fila-tile"
                  v-for="f in dados.filas.detalhe"
                  :key="f.queue"
                  :class="{ ativa: f.pendentes > 0 }"
                >
                  <i
                    class="fas fila-icone"
                    :class="infoFila(f.queue).icone"
                  ></i>
                  <div
                    class="fila-num"
                    :class="
                      f.pendentes > 50
                        ? 'text-warning'
                        : f.pendentes > 0
                        ? 'text-primary'
                        : 'text-secondary'
                    "
                  >
                    {{ f.pendentes }}
                  </div>
                  <div class="fila-nome">{{ infoFila(f.queue).nome }}</div>
                  <div class="fila-desc">{{ infoFila(f.queue).desc }}</div>
                </div>
              </div>
              <div
                class="alert mb-0 mt-3 py-2"
                :class="alertaFilas.classe"
                style="font-size: 13px"
              >
                <i class="fas mr-1 ml-1" :class="alertaFilas.icone"></i
                >{{ alertaFilas.texto }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Divisor: área técnica (escalonamento para a TI) -->
      <div class="tecnico-divisor mb-2">
        <i class="fas fa-tools mr-2"></i>
        <span>Detalhes técnicos</span>
        <small class="text-muted ml-2"
          >— para a equipe de TI. Em caso de problema, encaminhe estas
          informações.</small
        >
      </div>

      <!-- Lentidão + Exceções -->
      <div class="row">
        <div class="col-md-7 mb-3">
          <div class="card h-100">
            <div class="card-header py-2">
              <b
                ><i class="fas fa-tachometer-alt mr-2 text-warning"></i>Lentidão
                recente</b
              >
              <small class="text-muted ml-1">(via Pulse)</small>
            </div>
            <div class="card-body p-0">
              <table class="table table-sm mb-0" style="font-size: 13px">
                <thead>
                  <tr>
                    <th>Tipo</th>
                    <th>Descrição</th>
                    <th class="text-center">Qtd</th>
                    <th class="text-right">Pior</th>
                    <th>Última</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!dados.lentidao.length">
                    <td colspan="5" class="text-center text-muted py-3">
                      Nada lento no período 🎉
                    </td>
                  </tr>
                  <template v-for="(l, i) in dados.lentidao">
                    <tr
                      :key="'l' + i"
                      @click="toggle(expandLent, i)"
                      class="linha-click"
                    >
                      <td>
                        <i
                          class="fas fa-chevron-right mr-1 text-muted chevron"
                          :class="{ aberto: expandLent.includes(i) }"
                        ></i>
                        <span class="tipo-pill" :style="estiloTipo(l.tipo)">
                          <i class="fas mr-1" :class="iconeTipo(l.tipo)"></i
                          >{{ rotuloTipo(l.tipo) }}
                        </span>
                      </td>
                      <td>{{ truncar(l.descricao, 40) }}</td>
                      <td class="text-center">
                        <span class="badge badge-secondary"
                          >{{ l.ocorrencias }}×</span
                        >
                      </td>
                      <td
                        class="text-right font-weight-bold"
                        :class="l.ms > 1000 ? 'text-danger' : 'text-warning'"
                      >
                        {{ l.ms }}ms
                      </td>
                      <td class="text-muted">{{ l.ultima }}</td>
                    </tr>
                    <tr
                      v-if="expandLent.includes(i)"
                      :key="'ld' + i"
                      class="detalhe-row"
                    >
                      <td colspan="5">
                        <div class="detalhe-box">{{ l.descricao }}</div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-md-5 mb-3">
          <div class="card h-100">
            <div class="card-header py-2">
              <b
                ><i class="fas fa-bug mr-2 text-danger"></i>Exceções recentes</b
              >
              <small class="text-muted ml-1">(via Pulse)</small>
            </div>
            <div class="card-body p-0">
              <table class="table table-sm mb-0" style="font-size: 13px">
                <thead>
                  <tr>
                    <th>Erro</th>
                    <th class="text-center">Qtd</th>
                    <th>Última</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!dados.excecoes.length">
                    <td colspan="3" class="text-center text-muted py-3">
                      Sem exceções no período 🎉
                    </td>
                  </tr>
                  <template v-for="(e, i) in dados.excecoes">
                    <tr
                      :key="'e' + i"
                      @click="toggle(expandExc, i)"
                      class="linha-click"
                    >
                      <td>
                        <i
                          class="fas fa-chevron-right mr-1 text-muted chevron"
                          :class="{ aberto: expandExc.includes(i) }"
                        ></i>
                        {{ truncar(e.descricao, 32) }}
                      </td>
                      <td class="text-center">
                        <span
                          class="badge"
                          :class="
                            e.ocorrencias > 10
                              ? 'badge-danger'
                              : 'badge-warning'
                          "
                        >
                          {{ e.ocorrencias }}×
                        </span>
                      </td>
                      <td class="text-muted">{{ e.ultima }}</td>
                    </tr>
                    <tr
                      v-if="expandExc.includes(i)"
                      :key="'ed' + i"
                      class="detalhe-row"
                    >
                      <td colspan="3">
                        <div class="detalhe-box">{{ e.descricao }}</div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SaudeSistema",
  data() {
    return {
      carregando: false,
      autoRefresh: true,
      intervalo: null,
      periodo: "hoje",
      expandLent: [],
      expandExc: [],
      periodos: [
        { valor: "1h", label: "Última hora" },
        { valor: "hoje", label: "Hoje" },
        { valor: "7d", label: "7 dias" },
      ],
      dados: {
        infra: {},
        filas: { pendentes: 0, falhados: 0, detalhe: [] },
        lentidao: [],
        excecoes: [],
        gerado_em: null,
      },
    };
  },
  computed: {
    // Veredito geral para o suporte ler de relance.
    statusGeral() {
      const infra = this.dados.infra || {};
      const fora = Object.keys(infra).filter((k) => infra[k] && !infra[k].ok);
      const falhados = (this.dados.filas && this.dados.filas.falhados) || 0;
      const temExcecoes = (this.dados.excecoes || []).length > 0;

      // Crítico: serviço essencial fora (banco ou websocket)
      if (fora.includes("banco") || fora.includes("websocket")) {
        const nomes = fora.map((k) => this.rotuloInfra(k)).join(", ");
        return {
          nivel: "critico",
          titulo: "Problema crítico no sistema",
          detalhe: `Serviço essencial fora do ar: ${nomes}. Acione a equipe técnica imediatamente.`,
        };
      }

      // Atenção: redis fora, jobs falhados ou erros no período
      const motivos = [];
      if (fora.length)
        motivos.push(
          `${fora.map((k) => this.rotuloInfra(k)).join(", ")} indisponível`
        );
      if (falhados > 0) motivos.push(`${falhados} processamento(s) com falha`);
      if (temExcecoes) motivos.push("erros registrados no período");
      if (motivos.length) {
        return {
          nivel: "atencao",
          titulo: "Atenção — verificar",
          detalhe: motivos.join(" · ") + ".",
        };
      }

      return {
        nivel: "ok",
        titulo: "Tudo funcionando normalmente",
        detalhe: "Nenhum problema detectado no período selecionado.",
      };
    },
    // Interpretação das filas para quem não é técnico.
    alertaFilas() {
      const f = this.dados.filas || {};
      if ((f.falhados || 0) > 0) {
        return {
          classe: "alert-danger",
          icone: "fa-exclamation-circle",
          texto: `${f.falhados} processamento(s) falharam — alguns exports/sincronizações podem não ter concluído. Encaminhe à TI.`,
        };
      }
      if ((f.pendentes || 0) > 50) {
        return {
          classe: "alert-warning",
          icone: "fa-hourglass-half",
          texto:
            "Muitos jobs acumulados na fila — processamentos podem estar atrasados.",
        };
      }
      return {
        classe: "alert-success",
        icone: "fa-check-circle",
        texto: "Filas em dia — nada acumulado nem falhado.",
      };
    },
  },
  watch: {
    autoRefresh(ativo) {
      ativo ? this.iniciarPolling() : this.pararPolling();
    },
  },
  mounted() {
    this.carregar();
    if (this.autoRefresh) this.iniciarPolling();
  },
  beforeDestroy() {
    this.pararPolling();
  },
  methods: {
    carregar() {
      const self = this;
      const api = self.$store.state.api + "admin/saude";
      self.carregando = true;
      axios
        .get(api, { params: { periodo: self.periodo } })
        .then((response) => {
          self.dados = response.data;
          self.carregando = false;
        })
        .catch((error) => {
          self.carregando = false;
          self.$message(
            null,
            error.response
              ? error.response.data
              : "Erro ao carregar saúde do sistema",
            "error"
          );
        });
    },
    setPeriodo(valor) {
      this.periodo = valor;
      this.carregar();
    },
    toggle(lista, i) {
      const idx = lista.indexOf(i);
      idx === -1 ? lista.push(i) : lista.splice(idx, 1);
    },
    iniciarPolling() {
      this.pararPolling();
      this.intervalo = setInterval(this.carregar, 15000);
    },
    pararPolling() {
      if (this.intervalo) {
        clearInterval(this.intervalo);
        this.intervalo = null;
      }
    },
    rotuloInfra(nome) {
      return (
        {
          banco: "Banco de Dados",
          redis: "Redis (Cache/Filas)",
          websocket: "WebSocket (Reverb)",
        }[nome] || nome
      );
    },
    iconeInfra(nome) {
      return (
        { banco: "fa-database", redis: "fa-server", websocket: "fa-bolt" }[
          nome
        ] || "fa-circle"
      );
    },
    infoFila(queue) {
      return (
        {
          default: {
            nome: "Geral",
            desc: "Tarefas diversas",
            icone: "fa-list",
          },
          exports: {
            nome: "Relatórios",
            desc: "Excel / PDF",
            icone: "fa-file-export",
          },
          painel: {
            nome: "Painéis",
            desc: "Atualização de telas",
            icone: "fa-desktop",
          },
          sync: {
            nome: "Sincronização",
            desc: "Integração ARES",
            icone: "fa-sync",
          },
        }[queue] || { nome: queue, desc: "", icone: "fa-list" }
      );
    },
    descricaoInfra(nome) {
      return (
        {
          banco: "Guarda todos os dados. Se cair, o sistema para.",
          redis: "Cache e processamentos em segundo plano.",
          websocket: "Painéis e chamadas de senha em tempo real.",
        }[nome] || ""
      );
    },
    iconeStatus(nivel) {
      return (
        {
          ok: "fa-check-circle",
          atencao: "fa-exclamation-triangle",
          critico: "fa-times-circle",
        }[nivel] || "fa-question-circle"
      );
    },
    rotuloTipo(tipo) {
      return (
        {
          slow_request: "Request",
          slow_query: "Query",
          slow_job: "Job",
          slow_outgoing_request: "HTTP ext.",
        }[tipo] || tipo
      );
    },
    iconeTipo(tipo) {
      return (
        {
          slow_request: "fa-exchange-alt",
          slow_query: "fa-database",
          slow_job: "fa-cogs",
          slow_outgoing_request: "fa-cloud",
        }[tipo] || "fa-clock"
      );
    },
    estiloTipo(tipo) {
      const cores = {
        slow_request: { background: "#1565c0", color: "#fff" },
        slow_query: { background: "#2e7d32", color: "#fff" },
        slow_job: { background: "#7b1fa2", color: "#fff" },
        slow_outgoing_request: { background: "#e65100", color: "#fff" },
      };
      return cores[tipo] || { background: "#546e7a", color: "#fff" };
    },
    truncar(texto, n) {
      if (!texto) return "—";
      return texto.length > n ? texto.substring(0, n) + "…" : texto;
    },
  },
};
</script>

<style scoped>
/* Banner de status geral */
.status-banner {
  display: flex;
  align-items: center;
  border-radius: 10px;
  padding: 16px 20px;
  border-left: 6px solid;
}
.status-banner .sb-titulo {
  font-size: 18px;
  font-weight: 700;
}
.status-banner .sb-detalhe {
  font-size: 14px;
  opacity: 0.85;
}
.sb-ok {
  background: #e8f5e9;
  border-left-color: #28a745;
  color: #1b5e20;
}
.sb-atencao {
  background: #fff8e1;
  border-left-color: #d29922;
  color: #8a6d1b;
}
.sb-critico {
  background: #fdecea;
  border-left-color: #dc3545;
  color: #a11b1b;
}

/* Divisor da área técnica */
.tecnico-divisor {
  display: flex;
  align-items: center;
  font-weight: 700;
  color: #546e7a;
  font-size: 15px;
  border-top: 1px dashed #cfd8dc;
  padding-top: 14px;
  margin-top: 8px;
}

/* Tiles das filas */
.filas-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
}
.fila-tile {
  border: 1px solid #e3e8ef;
  border-radius: 10px;
  padding: 14px 10px;
  text-align: center;
  background: #fafbfc;
  transition: all 0.15s ease;
}
.fila-tile.ativa {
  border-color: #b3d4ff;
  background: #f0f7ff;
}
.fila-icone {
  font-size: 16px;
  color: #90a4ae;
  margin-bottom: 4px;
}
.fila-tile.ativa .fila-icone {
  color: #1565c0;
}
.fila-num {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.1;
}
.fila-nome {
  font-size: 13px;
  font-weight: 600;
  color: #37474f;
}
.fila-desc {
  font-size: 11px;
  color: #90a4ae;
}

.border-left-status {
  border-left: 4px solid #ccc;
}
.st-ok {
  border-left-color: #28a745;
}
.st-down {
  border-left-color: #dc3545;
}

/* Badges de tipo na tabela de lentidão (cores vêm via :style inline) */
.tipo-pill {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 3px 10px;
  border-radius: 20px;
  white-space: nowrap;
}

/* Linhas clicáveis e detalhe expandido */
.linha-click {
  cursor: pointer;
}
.linha-click:hover {
  background: #f3f6fa;
}
.chevron {
  transition: transform 0.15s ease;
  font-size: 10px;
}
.chevron.aberto {
  transform: rotate(90deg);
}
.detalhe-row td {
  background: #f8f9fb;
}
.detalhe-box {
  font-family: "SF Mono", Consolas, Monaco, monospace;
  font-size: 12px;
  color: #2d3748;
  word-break: break-all;
  white-space: pre-wrap;
  padding: 4px 2px 4px 22px;
}
</style>
